// extracted by mini-css-extract-plugin
module.exports = {"container":"MainContent_container__1m232","posts":"MainContent_posts__11ect"};